import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Button, Box, IconButton } from '@mui/material';
import NewDamageForm from "../components/NewDamageForm.js"
import axios from "axios";
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DamageItemRec from '../components/DamageItemRec.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DamageControlPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);
  const [selectedRowDataPreview, setSelectedRowDataPreview] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])

  const [isNewDamageFormOpen, setIsNewDamageFormOpen] = useState(false);
  let [selectedRow, setSelectedRow] = useState(null);
  let [selectedRowData, setSelectedRowData] = useState(null);

  const openNewDamageForm = () => {
    setIsNewDamageFormOpen(true);
    setSelectedRowData(null);
  };

  // Function to close the form
  const closeNewDamageForm = () => {
    setIsNewDamageFormOpen(false);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchDamages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/damages/all_damages`);
        const responseData = await response.json();
        if (responseData) {
          // console.log(responseData.vendor)
          setData(responseData.damage);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }

    fetchDamages();

  }, [isNewDamageFormOpen]);

  const [totalDamages, setTotalDamages] = useState(0);

  useEffect(() => {
    // Calculate the total damages when the data changes
    const calculateTotalDamages = () => {
      const damagesSum = data && data.reduce((sum, damage) => sum + Number(damage.damageamount), 0);
      setTotalDamages(damagesSum);
    };

    calculateTotalDamages();
  }, [data]);

  const DeleteDamage = async (selectedRowId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/damages/delete_damage`, {
        data: {
          id: selectedRowId
        }
      });
      if (response.status === 200) {
        toast.success(`Damage with id: "${selectedRowId}" deleted successfully.`)
      } else {
        toast.error("Failed to delete damage.");
      }
    } catch (error) {
      toast.error("Error deleting damage.");
    }
  };


  const columns = useMemo(
    () => [
      {
        accessorKey: 'damageitem', //access nested data with dot notation
        header: 'Damage Item',
        size: 100,
      },
      {
        accessorKey: 'damagequantity', //normal accessorKey
        header: 'Damage Quantity',
        size: 200,
      },
      {
        accessorKey: 'damagedate',
        header: 'Damage Date',
        size: 100,
        Cell: ({ cell }) => (
          `${cell.getValue() ? cell.getValue().slice(0, 10) : "Unavailable"}`
        )
      },
    ],
    [],
  );


  return (
    <>
      <StickyTitle title="Damages" button_action={openNewDamageForm} button="New Damage" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-3">
          <div className='text-2xl ml-2 font-bold font-poppins'>All Damages</div>
          <h2 className=' text-end text-sm sm:text-xl text-black'> Total Damages:<span className='ml-1 text-lg md:text-2xl font-bold'>{`QAR ${totalDamages} `}</span></h2>
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns}
            data={data}
            renderRowActions={({ row }) => (
              <Box>
                <IconButton onClick={() => {
                  let rowData = row.original;
                  setSelectedRowDataPreview(rowData)
                  setIsPopupOpen(true);
                }}>
                  <ReceiptIcon />
                </IconButton>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting Damage with ID: ' + selectedRowId);
                  DeleteDamage(selectedRowId)
                } else {
                  alert('Please select a single row to delete.');
                }
              };
              const handleEdit = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  const selectedRow = selectedRows[0];
                  const selectedRowData = selectedRow.original;
                  setSelectedRowData(selectedRowData);
                  setIsNewDamageFormOpen(true); // Open the form
                } else {
                  alert('Please select a single row to Edit.');
                }
              };


              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}
                  >
                    Delete
                  </Button>
                  <Button
                    color="success"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleEdit}
                    variant="contained"
                  >
                    Edit
                  </Button>
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>) : (null)}
      </div>

      <NewDamageForm isOpen={isNewDamageFormOpen} onClose={closeNewDamageForm} selectedRowData={selectedRowData} />

      <div>
        {isPopupOpen && (
          <div style={{
            display: isPopupOpen ? 'block' : 'none',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            height: '90vh',
            overflowY: 'auto',
            width: '800px'
          }}>

            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
              onClick={() => setIsPopupOpen(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <DamageItemRec
              itemname={selectedRowDataPreview.damageitem}
              quantity={selectedRowDataPreview.damagequantity}
              date={selectedRowDataPreview.damagedate}
            />
          </div>
        )}
      </div>

    </>
  );
};

export default DamageControlPage;
